import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=4901cd95&scoped=true&"
import script from "./CandidateInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateInfo.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInfo.vue?vue&type=style&index=0&id=4901cd95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901cd95",
  null
  
)

component.options.__file = "CandidateInfo.vue"
export default component.exports